import { useEffect } from "react";
import { newProductPlanActions } from "redux/Ldb/actions/newProductPlanActions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useUnpinNewProductPlan = (id?: string, skip = false) => {
    const dispatch = useAppDispatch();

    const {
        unpinningNewProductPlan,
        unpinnedNewProductPlanSuccess,
        unpinnedNewProductPlanFailure,
    } = useAppSelector((state) => state.newProductPlan);

    const handleUnpinNewProductPlan = (productPlanId: string) => {
        dispatch(newProductPlanActions.unpinNewProductPlan(productPlanId));
    };

    useEffect(() => {
        if (id && !skip) {
            handleUnpinNewProductPlan(id);
        }
    }, [id, skip]);

    useEffect(() => {
        if (Boolean(unpinnedNewProductPlanSuccess)) {
            dispatch(newProductPlanActions.resetUnpinNewProductPlan());
        }
    }, [unpinnedNewProductPlanSuccess, dispatch]);

    const unpinNewProductPlan = (productPlanId: string) => {
        handleUnpinNewProductPlan(productPlanId);
    };

    return {
        isSuccess: Boolean(unpinnedNewProductPlanSuccess),
        isError: Boolean(unpinnedNewProductPlanFailure),
        isLoading: unpinningNewProductPlan,
        data: unpinnedNewProductPlanSuccess,
        error: unpinnedNewProductPlanFailure,
        unpinNewProductPlan,
    };
};

export default useUnpinNewProductPlan;
